/**
 * Parses a failed support ticket API response into a user-facing message.
 *
 * @param response - Non-OK fetch response from the support tickets API.
 * @param fallbackMessage - Message used when the body cannot be parsed.
 * @returns Error message suitable for toast or inline display.
 */
export async function parseSupportTicketApiError(
  response: Response,
  fallbackMessage: string,
): Promise<string> {
  try {
    const body = (await response.json()) as {
      detail?: string | Array<{ msg?: string }>;
    };

    if (Array.isArray(body.detail)) {
      const messages = body.detail
        .map((entry) => entry.msg?.trim())
        .filter(Boolean);
      if (messages.length > 0) {
        return messages.join(", ");
      }
    }

    if (typeof body.detail === "string" && body.detail.trim()) {
      return body.detail.trim();
    }
  } catch {
    // Fall through to generic message below.
  }

  return `${fallbackMessage} (${response.status}).`;
}
